import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useAppStore } from '../../store/store';
import { formatDocumentTitle } from './formatDocumentTitle';
import { usePageTitleStore } from './pageTitleStore';
import { resolveBrand } from './resolveBrand';
import { resolveRouteTitleKey } from './resolveRouteTitleKey';

/** Single writer of `document.title`. Mount once under the router. */
export function DocumentTitleSync() {
  const { pathname, key } = useLocation();
  const { t } = useTranslation();
  const brand = useAppStore((s) => resolveBrand(s.brandingData));
  const titleState = usePageTitleStore((s) => s.state);
  const scoped = titleState?.locationKey === key ? titleState : null;

  useEffect(() => {
    const routeLabel = t(resolveRouteTitleKey(pathname));
    const pageLabel = scoped?.label?.trim() ? scoped.label : routeLabel;
    document.title = formatDocumentTitle({
      status: scoped?.status ?? 'ready',
      pageLabel,
      brand,
      t,
    });
  }, [pathname, key, brand, t, scoped?.status, scoped?.label]);

  return null;
}
